
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ja. Jedenfalls, wenn es nach Wissenschaftlern aus Stockholm geht. Forscher des Karolinska-Instituts in Stockholm führten 2010 ein `}<Link href='https://www.ncbi.nlm.nih.gov/pubmed/21156746' mdxType="Link">{`Experiment zum
Thema «Schönheitsschlaf»`}</Link>{` durch. 23 Teilnehmer im Alter von 18 bis 31 Jahren wurden fotografiert – einmal nach normalem Schlaf und einmal, ohne davor geschlafen zu haben. 65 neutrale Beobachter mussten die Fotos nach der Attraktivität der Abgebildeten und nach dem Gesundheitszustand einordnen. Das Resultat war eindeutig: `}<M mdxType="M">{`Alle Probanden, die wenig geschlafen hatten, wurden als «müder, weniger gesund und deutlich weniger attraktiv» beurteilt.`}</M>{` `}<br /><br />{`
2017 wiederholte die Psychologin Tina Sundelin von der Universität Stockholm das Experiment mit einem etwas angepassten Setting. Für `}<Link href='http://su.diva-portal.org/smash/record.jsf?pid=diva2%3A1117488&dswid=2213' mdxType="Link">{`ihre Studie`}</Link>{` liess sie 25 gesunde Frauen und Männer zwischen 18 und 47 Jahren mit den gleichen Lichtverhältnissen fotografieren. Die einen kamen ausgeschlafen ans Shooting, die anderen waren bereits seit zwei Tagen wach. Die Fotos wurden von 122 Beobachtern, die nichts über das Ziel des Experiments wussten, bewertet. Sie alle mussten angeben, mit welcher oder welchem der Teilnehmenden sie gerne etwas unternehmen würden. Zudem mussten sie die Attraktivität, die Gesundheit, die Schläfrigkeit und die Vertrauenswürdigkeit der Probandinnen und Probanden bewerten. `}<M mdxType="M">{`Das Ergebnis: Die Beobachter wollten sich eher mit den Ausgeschlafenen treffen und austauschen.`}</M>{` Darüber hinaus wurden die Unausgeschlafenen als weniger attraktiv, weniger gesund und schläfriger wahrgenommen. Immerhin müssen sich Kurzschläfer keine Gedanken bezüglich ihrer Vertrauenswürdigkeit machen: Hier gab es keinen Unterschied.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;